export const contactData = {
    phone_display: '(+36) 20 297 2717',
    phone_href: '0036202972717',
    email: 'hillmedical.info@gmail.com',
    address: {
        postcode: '9081',
        city: 'Győrújbarát',
        street: 'Dr. Baróti Lajos u. 14/A'
    },
    address_href: 'https://maps.app.goo.gl/ruqhyhYdKqZMn4yi8'
}